"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.042 35.261c-1.226 1.14-2.442 2.262-3.648 3.392-.42.395-.895.614-1.498.584-.412-.022-.644-.194-.77-.567-.924-2.733-1.86-5.459-2.779-8.195-.09-.265-.22-.393-.503-.476a622.166 622.166 0 0 1-6.509-1.939 3.792 3.792 0 0 1-.96-.422c-.445-.286-.51-.753-.11-1.091a4.435 4.435 0 0 1 1.266-.757c2.657-1.005 5.33-1.976 7.999-2.957l20.313-7.48c1.287-.475 2.277.194 2.145 1.522-.087.85-.317 1.685-.503 2.523-1.471 6.622-2.942 13.244-4.421 19.864-.352 1.571-1.509 1.983-2.865 1.029-2.271-1.598-4.541-3.199-6.811-4.798-.108-.076-.223-.149-.346-.232Zm-5.099 2.01.078-.017c.013-.062.034-.123.04-.185.145-1.502.3-3.002.426-4.505a1.083 1.083 0 0 1 .414-.799c2.094-1.785 4.175-3.582 6.26-5.375 2.309-1.986 4.618-3.97 6.918-5.964.142-.123.203-.332.299-.503-.216-.022-.45-.105-.645-.056-.269.068-.524.215-.762.358-5.095 3.06-10.186 6.128-15.284 9.181-.287.174-.341.321-.232.622.375 1.03.718 2.069 1.073 3.107l1.415 4.138v-.002Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTelegram);
var _default = exports["default"] = Memo;